import React from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import Loading from "components/Loader/Spinner";
import CustomSpinner from "components/Loader/CustomSpinner";
import {
  BACKGROUND_WALLET,
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,

} from "src/constants/images";
import { replaceFloatValue } from "utils/replaceFloatValue";

// const TRACKER_URL = import.meta.env.VITE_ICON_TRACKER_URL
const Loader = ({ toAddressFinal, currentName }) => (
  <>
    <div className="header">
      <img
        src={BACKGROUND_WALLET.SOURCE}
        alt="background"
        className="background-wallet"
      />
      {/* {cost > 0 ? (
        <h4 className="mb-2">Wallet connected!</h4>
      ) : (
        <h4 className="mb-2">Wallet connected!</h4>
      )} */}

    </div>
    <div className="body loading">
      <CustomSpinner />
    </div>
    <div className="footer">
      <p className="py-2">
        
        <br />
        {`Transferring ${currentName} to address ${toAddressFinal}`} <br />
        Please wait..
      </p>

      <button disabled className="btn btn-outline-secondary close">
        Close
      </button>
    </div>
  </>
);

const Success = ({ onClick,toAddressFinal, currentName,tx}) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-3">Success!</h4>
      {/* {cost > 0 ? (
        <p className="text">
          You successfully listed your GangstaBet at {cost} ICX ($
          {replaceFloatValue(icxInUSD * cost)}).
        </p>
      ) : (
        <p className="text">
          You successfully removed your GangstaBet listing.
        </p>
      )} */}
      
       <p className="text">
          You successfully <u ><a style={{color:"var(--text-color)"}} href={`https://tracker.icon.community/transaction/${tx}`} target="_blank">transferred</a></u> {currentName} to address {toAddressFinal}
        </p>
    </div>
    <div className="body">
      <img
        src={COMPLETE_TRANSACTION.SOURCE}
        alt="transaction completed"
        className="d-block mx-auto my-3"
      />

      <button
        className="btn btn-outline-primary profile"
        onClick={() => onClick("sale")}
      >
        Close
      </button>
    </div>
  </>
);

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Cancelled</h4>
      <p className="text my-3">Transaction cancelled.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick, message }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Failed</h4>
      <p className="text my-3">
        Could not complete due to transaction failure, please try again after
        sometime!
        <br />
        {message}
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const TransferNFTLoader = ({ response, onClick, isVisible,toAddressFinal,
  currentName }) => {
  const icxInUSD = useSelector((state) => state.icxPricing.price);

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {response.status === "success" ? (
        <>
        <Success onClick={onClick} tx={response.tx} toAddressFinal={toAddressFinal} currentName={currentName}   />
        </>
      ) : response.status === "cancel" ? (
        <Cancel onClick={onClick} />
      ) : response.status === "error" ? (
        <Error onClick={onClick} />
      ) : (

        <Loader toAddressFinal={toAddressFinal} currentName={currentName} />
      )}
    </Modal>
  );
};

export default TransferNFTLoader;
